import { BarChart3 } from "lucide-react";
import { ComingNext } from "@/components/ComingNext";

export default function AnalyticsPage() {
  return (
    <ComingNext
      testId="analytics-page"
      icon={BarChart3}
      eyebrow="Analytics"
      title="Views and saves."
      description="See when your card and public profile are viewed and saved, once they are live."
    />
  );
}
